import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import AssetManagementApiService from './AssetManagementApiService'
import { GET_REASON_TYPE } from '../../Store/AssetManagement/ReasonType/ReasonTypeType'
import { setReasonType } from 'Store/AssetManagement/ReasonType/ReasonTypeAction';
import { apiMethod, apiType, API_URL } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getReasonTypes(_req: any): any {

    let payloadData : IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `assets/dropdown/reasontypes`,
        payload : null
    }

    try {
        yield put(globalLoaderText("Fetching Reason Types...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if(response?.length > 0){
        const defaultReasonTypeOption = {
            text: "Select Reason Type",
            value: null
        };
        response.unshift(defaultReasonTypeOption);
    }
        yield put(setReasonType(response))

        yield put(globalLoaderText(""));

    } catch (error) {
        yield put(setReasonType([]))
        yield put(globalLoaderText(""));
    }
}

function* watchGetReasonTypes() {
    yield takeEvery(GET_REASON_TYPE, getReasonTypes)
}

export default function* combinedSaga() {
    yield all([
        watchGetReasonTypes()
    ])
}
